import React from 'react';

import { Text } from '@reckon-web/text';

import { Dialog } from '../components/common/dialog';
import { useJobSignOffWithdraw as _useJobSignOffWithdraw } from '../data/useJobSignOffWithdraw';

import { Job } from './use-query-job';
import { useDialog } from './use-dialog';

const JobSignOffWithdrawDialog: React.FC<{
  onClose: (ok?: boolean) => void;
}> = ({ onClose }) => {
  return (
    <Dialog
      title="Withdraw the sign off request?"
      cancelLabel="Cancel"
      onCancel={onClose}
      submitLabel="Yes, withdraw"
      onSubmit={() => onClose(true)}
    >
      <Text>The sign off request will be marked as "withdrawn".</Text>
    </Dialog>
  );
};

export const useJobSignOffWithdraw = () => {
  const [_jobSignOffWithdraw] = _useJobSignOffWithdraw(); // TODO: handle loading and error states

  const [Dialog, openDialog] = useDialog();

  const jobSignOffWithdraw = React.useCallback(
    async (job: Job) => {
      const res = await openDialog<boolean>(JobSignOffWithdrawDialog, {
        size: 'small',
      });
      if (!res) return;

      return _jobSignOffWithdraw({ variables: { cloudId: job.cloudId || '' } });
    },
    [_jobSignOffWithdraw, openDialog]
  );

  return React.useMemo(
    () =>
      [Dialog, jobSignOffWithdraw] as [
        typeof Dialog,
        typeof jobSignOffWithdraw,
      ],
    [Dialog, jobSignOffWithdraw]
  );
};
